module.exports = __webpack_public_path__ + "uK9sO6mmf5L0OqWIh/icon_info.svg";